import {
  HANDLE_EDIT_JOB,
  HANDLE_PIPELINE_LIST,
  SET_JOB_DETAILS,
  OPEN_CONFIRM,
  CLOSE_CONFIRM,
  OPEN_STOP_CONFIRM,
  CLOSE_STOP_CONFIRM,
  OPEN_CONFLICT_CONFIRM,
  CLOSE_CONFLICT_CONFIRM,
} from "../actions/types";

const initialState = {
  editJob: null,
  dataPipelineList: false,
  job: {},
  confirmPopupOpen: { open: false, Job_id: null, JobType: null },
  stopConfirmPopupOpen: { open: false, Job_id: null, JobName: "", JobType: null },
  conflictConfirmPopupOpen: { open: false, Job_id: null, data: null, JobType: null },
};

export const dataPipelineReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HANDLE_EDIT_JOB:
      return { ...state, editJob: payload };
    case HANDLE_PIPELINE_LIST:
      return { ...state, dataPipelineList: payload };
    case SET_JOB_DETAILS:
      return { ...state, job: { ...state.job, ...payload } };
    case OPEN_CONFIRM:
      return { ...state, confirmPopupOpen: { open: true, ...payload } };
    case CLOSE_CONFIRM:
      return { ...state, confirmPopupOpen: { open: false } };
    case OPEN_STOP_CONFIRM:
      return { ...state, stopConfirmPopupOpen: { open: true, ...payload } };
    case CLOSE_STOP_CONFIRM:
      return { ...state, stopConfirmPopupOpen: { open: false } };
    case OPEN_CONFLICT_CONFIRM:
      return { ...state, conflictConfirmPopupOpen: { open: true, ...payload } };
    case CLOSE_CONFLICT_CONFIRM:
      return { ...state, conflictConfirmPopupOpen: { open: false } };
    default:
      return state;
  }
};
